/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{display:block;padding-bottom:2em;position:relative}@media (min-width:600px){[_nghost-%COMP%]{width:80vw;max-width:80vw}}[_nghost-%COMP%] > button[_ngcontent-%COMP%]{position:absolute;right:8px;top:5px;background-color:#fff}[_nghost-%COMP%] > .actions[_ngcontent-%COMP%]{position:absolute;bottom:-18px;right:.5em}[_nghost-%COMP%] > .actions[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{margin:0 .5em}[_nghost-%COMP%] > .actions[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]:first-of-type{margin-left:0}[_nghost-%COMP%] > .actions[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]:last-of-type{margin-right:0}"];
export { styles as styles };



// WEBPACK FOOTER //
// ./src/app/material/material-dialog/material-dialog.component.scss.shim.ngstyle.js.pre-build-optimizer.js